import React, { useEffect } from 'react';
import { Autocomplete, Button, Dialog, Grid, MenuItem, TextField, Typography } from '@mui/material';
import { Form, getIn } from 'formik';

const Add = ({
    open,
    setOpen,
    values,
    setFieldValue,
    touched,
    errors,
    handleChange,
    resetForm,
    fetchSessions,
    fetchCourseDetails,
    fetchExams
}) => {
    useEffect(() => {
        fetchSessions();
    }, []);
    return (
        <Dialog open={open}>
            <Form>
                <Grid container spacing={2} alignItems="center" p={3}>
                    <Grid item xs={12}>
                        <Typography variant="h4">Create Exam</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            select
                            id="sessionIds"
                            name="sessionIds"
                            label="Select Batch*"
                            value={values?.sessionIds[0] || ''}
                            onChange={(event) => {
                                handleChange(event);
                                const selectedValue = event.target.value;
                                fetchCourseDetails(selectedValue);
                                setFieldValue('sessionIds', [selectedValue]);
                            }}
                            error={errors.sessionIds && touched.sessionIds && <div>{errors.sessionIds}</div>}
                            helperText={errors.sessionIds && touched.sessionIds && <div>{errors.sessionIds}</div>}
                        >
                            {values?.sessionList
                                ?.filter((elem) => !elem?.forPhd)
                                ?.map((s) => (
                                    <MenuItem key={s?.id} value={s?.id}>
                                        {s?.tag}
                                    </MenuItem>
                                ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            limitTags={2}
                            multiple
                            disableCloseOnSelect
                            options={
                                values?.courseDetailList?.sort((a, b) => {
                                    const nameA = a?.course?.courseName.trim().toLowerCase();
                                    const nameB = b?.course?.courseName.trim().toLowerCase();
                                    return nameA.localeCompare(nameB);
                                }) || []
                            }
                            id="courseDetailIds"
                            name="courseDetailIds"
                            value={values?.courseDetailIds?.map((id) => values?.courseDetailList?.find((option) => option?.id === id))}
                            onChange={(event, newValue) => {
                                setFieldValue(
                                    'courseDetailIds',
                                    newValue.map((option) => option?.id)
                                );
                            }}
                            getOptionLabel={(option) => option?.course?.courseName.toUpperCase()}
                            getOptionSelected={(option, value) => option?.id === value?.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Programs *"
                                    error={getIn(errors, `courseDetailIds`) && getIn(touched, `courseDetailIds`)}
                                    helperText={
                                        getIn(errors, `courseDetailIds`) && getIn(touched, `courseDetailIds`)
                                            ? getIn(errors, `courseDetailIds`)
                                            : ''
                                    }
                                    renderOption={(props, option) => (
                                        <li {...props} key={option?.id}>
                                            {option?.course?.courseName.toUpperCase()}
                                        </li>
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="examMode"
                            name="examMode"
                            label="Paper Mode"
                            select
                            value={values.examMode}
                            onChange={handleChange}
                        >
                            <MenuItem value="REGULAR">REGULAR</MenuItem>
                            <MenuItem value="BACK">BACK</MenuItem>
                            <MenuItem value="IMPROVEMENT">IMPROVEMENT</MenuItem>
                            <MenuItem value="REEVALUATION">RE-EVALUATION</MenuItem>
                            <MenuItem value="SPECIAL_REPEAT">SPECIAL REPEAT</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            select
                            id="semesterNo"
                            name="semesterNo"
                            label="Select Semester"
                            value={values?.semesterNo}
                            onChange={handleChange}
                            error={touched.semesterNo && Boolean(errors.semesterNo)}
                            helperText={touched.semesterNo && errors.semesterNo}
                        >
                            {values?.semList?.map((s) => (
                                <MenuItem key={s} value={s}>
                                    {s}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="examName"
                            name="examName"
                            label="Exam Name"
                            value={values?.examName}
                            onChange={handleChange}
                            error={touched.examName && Boolean(errors.examName)}
                            helperText={touched.examName && errors.examName}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="date"
                            label="Exam Start Date"
                            id="startDate"
                            name="startDate"
                            value={values?.startDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            error={touched.startDate && Boolean(errors.startDate)}
                            helperText={touched.startDate && errors.startDate}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="date"
                            id="endDate"
                            label="Exam End Date"
                            name="endDate"
                            value={values?.endDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            error={touched.endDate && Boolean(errors.endDate)}
                            helperText={touched.endDate && errors.endDate}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'end' }}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                resetForm();
                                setOpen(false);
                                fetchExams();
                            }}
                            color="error"
                        >
                            Cancel
                        </Button>
                        <Button variant="contained" type="submit">
                            {values?.type === 'EDIT' ? 'Update Exam' : 'Create Exam'}
                        </Button>
                    </Grid>
                </Grid>
            </Form>
        </Dialog>
    );
};

export default Add;
